import React, { useContext } from 'react';
import classNames from 'classnames';
import cls from './EstimateMeasurementsModal.module.css';
import { EstimateMeasurementsModalHeader } from './EstimateMeasurementsModalHeader/EstimateMeasurementsModalHeader';
import { EstimateMeasurementsModalImages } from './EstimateMeasurementsModalImages/EstimateMeasurementsModalImages';
import { EstimateMeasurementsModalBody } from './EstimateMeasurementsModalBody/EstimateMeasurementsModalBody';
import { EstimateMeasurementsContext } from '../Context/EstimateMeasurementsContext';
import { EstimateMeasurementsModalSelect } from './EstimateMeasurementsModalSelect/EstimateMeasurementsModalSelect';
import { EstimateMeasurementsModalComment } from './EstimateMeasurementsModalComment/EstimateMeasurementsModalComment';

export const EstimateMeasurementsModal = () => {
    const { imageList } = useContext(EstimateMeasurementsContext);
    return (
        <div className={classNames(cls.EstimateMeasurementsModal)}>
            <div className={cls.containerFixed}>
                <EstimateMeasurementsModalHeader />
                <EstimateMeasurementsModalSelect />
            </div>
            {!!imageList.length && <EstimateMeasurementsModalImages />}
            <EstimateMeasurementsModalComment />
            <EstimateMeasurementsModalBody />
        </div>
    );
};
